// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, COMMON_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/user'
const JOIN_USER = () => {
	return {
		userName: null,
		birthyyMmday: null,
		gender: null,
		mobileNo: null,
		userId: null,
		password: null,
		email: null,
		nickname: null,
		memberGb: null,
		jobNo: null,
		pstNo: null,
		usetermsApplyYn: null,
		privacyApplyYn: null,
		mktRecvApplyYn: null,
		smsRecvYn: null,
		emailRecvYn: null,
		clientNo: null,
		ticketCd: null,
		division: null,
		trialUser: false
	}
}
const state = {
	joinUser: {
		userName: null,
		birthyyMmday: null,
		gender: null,
		mobileNo: null,
		userId: null,
		password: null,
		email: null,
		nickname: null,
		memberGb: null,
		jobNo: null,
		pstNo: null,
		usetermsApplyYn: null,
		privacyApplyYn: null,
		mktRecvApplyYn: null,
		smsRecvYn: null,
		emailRecvYn: null,
		clientNo: null,
		ticketCd: null,
		division: null,
		trialUser: false
	}
}

const mutations = {
	setJoinUser (state, form) {
		if (form.division) state.joinUser.division = form.division
		if (form.userName) state.joinUser.userName = form.userName
		if (form.birthyyMmday) state.joinUser.birthyyMmday = form.birthyyMmday
		if (form.gender) state.joinUser.gender = form.gender
		if (form.mobileNo) state.joinUser.mobileNo = form.mobileNo
		if (form.userId) state.joinUser.userId = form.userId
		if (form.password) state.joinUser.password = form.password
		if (form.email) state.joinUser.email = form.email
		if (form.nickname) state.joinUser.nickname = form.nickname
		if (form.memberGb) state.joinUser.memberGb = form.memberGb
		if (form.jobNo) state.joinUser.jobNo = form.jobNo
		if (form.pstNo) state.joinUser.pstNo = form.pstNo
		if (form.usetermsApplyYn) state.joinUser.usetermsApplyYn = form.usetermsApplyYn
		if (form.privacyApplyYn) state.joinUser.privacyApplyYn = form.privacyApplyYn
		if (form.mktRecvApplyYn) state.joinUser.mktRecvApplyYn = form.mktRecvApplyYn
		if (form.smsRecvYn) state.joinUser.smsRecvYn = form.smsRecvYn
		if (form.emailRecvYn) state.joinUser.emailRecvYn = form.emailRecvYn
		if (form.clientNo) state.joinUser.clientNo = form.clientNo
		if (form.ticketCd) state.joinUser.ticketCd = form.ticketCd
		if (form.trialUser) state.joinUser.trialUser = form.trialUser
	},
	initJoinUser (state) {
		state.joinUser = JOIN_USER()
	}
}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {

	/**
	 * 회원가입 > 아이디찾기 > 등록된 아이디 목록 조회
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async getMemberIds ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/join/ids`, payload)
	},

	/**
	 * 회원가입 > 아이디찾기 > 회원등록 유뮤 조회
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async checkMemberExist ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/join/exist`, payload)
	},

	/**
	 * 회원가입 > 본인 휴대폰 인증 > 사용자 핸드폰번호+인증코드번호 인증절차 처리.
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async checkAuthCode ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/joinAuth/checkAuthCode`, payload)
	},

	/**
	 * 회원가입 > 본인 휴대폰 인증 > 인증코드번호 발행.
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async generateSetAuthCode ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/joinAuth/generateAuthCode`, payload)
	},

	/**
	 * 회원가입 > 회원 등록.
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async setJoinRegistration ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/join`, payload)
	},

	/**
	 * 회원가입 > 닉네임 중복체크.
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async getUserReduNicknameInner ({commit}, payload) {
		return transmission(false, WEB_METHODS.GET, `${INNER_ROOT + ROOT}/join/nickname-redu/{nickname}`, payload)
	},

	/**
	 * 회원 > 회원가입 > 아이디 중복검사
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async getUserReduUseridInner ({commit}, payload) {
		return transmission(false, WEB_METHODS.GET, `${INNER_ROOT + ROOT}/join/userid-redu/{userId}/{clientNo}`, payload)
	},

	/**
     * 회원 > 회원정보 변경
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setMemberInfoInner ({commit}, payload) {
        return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/join/info/modify`, payload)
    },

	/**
     * 회원 > 패스워드 사용기간 설정 (6개월 뒤 설정)
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setMemberMaximumPasswordAgeInner ({commit}, payload) {
        return transmission(false, WEB_METHODS.PUT, `${INNER_ROOT + ROOT}/join/info/maximum-password-age`, payload)
    },

	/**
     * 회원 > 기업회원 아이디 찾기
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async getClientSearch ({commit}, payload) {
        return transmission(false, WEB_METHODS.GET, `${INNER_ROOT + ROOT}/join/client`)
    },

	/**
     * 회원 > 고객사정보 조회
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async getClientInfo ({commit}, payload) {
        return transmission(false, WEB_METHODS.GET, `${INNER_ROOT + ROOT}/join/client-info/{clientNo}`, payload)
    },

	/**
	 * 트라이얼 유저 회원가입 > 본인인증 정보 조회
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async getTrialAuthInfo ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/join/trial-auth-info`, payload)
	},

}

export default { state, mutations, actions }
